import { Component, Input, output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ValidationErrorsComponent } from '../../../../../../../common/validation-errors/validation-errors.component';
import { LocationDecisionItemForm } from '../location-decision-item.form';
import { LocationDecisionAppEntityLocationDecisionWrite } from '../../../../../../../openapi';
import { DatePickerComponent } from '../../../../../../../common/date-picker/date-picker.component';

@Component({
  selector: 'app-location-decision-item-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    ValidationErrorsComponent,
    DatePickerComponent
  ],
  templateUrl: './location-decision-item-form.component.html'
})
export class LocationDecisionItemFormComponent {

  public submit = output<LocationDecisionAppEntityLocationDecisionWrite>();

  public cancel = output<void>();

  @Input()
  public form: LocationDecisionItemForm | undefined;

  @Input()
  public edit = false;

  @Input()
  public showCancel = true;

  public onSubmit(): void {
    if (this.form?.valid) {
      this.submit.emit(this.form.value);
      this.form.reset();
    } else {
      this.form?.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.cancel.emit();
    this.form?.reset();
  }
}
